import { editAtom } from '@moleculeone/draw';

import {
  INCREASE_ATOM_CHARGE_MODE,
  MOL_MOUSE_EVENT,
  MOUSE_DOWN,
  MOUSE_MOVE,
  MOUSE_UP,
} from '../../../../etc/constants';
import { updateMols, updateState } from '../../../state';

export default function (modeType) {
  const initial = {
    type: modeType,
    data: null,
  };

  function effect(state, action) {
    if (action.type !== MOL_MOUSE_EVENT) {
      return {};
    }

    return baseEffect(state.mols, state.mode, action.event, state.mouse.molIndex);
  }

  function baseEffect(mols, mode, event, molIndex) {
    if (event.type === MOUSE_MOVE) {
      return {};
    }

    const data = mode.data;
    let newMol = mols[molIndex];

    if (event.type === MOUSE_DOWN && data != null) {
      //
    } else if (event.type === MOUSE_UP && data == null) {
      if (event.atom) {
        const atom = newMol.atoms[event.idx];
        const modifier = modeType === INCREASE_ATOM_CHARGE_MODE ? 1 : -1;
        const newCharge = atom.charge + modifier;

        if (newCharge >= -8 && newCharge <= 8) {
          newMol = editAtom(newMol, event.idx, undefined, newCharge);
        }
      } else if (event.bond) {
        //
      } else if (event.empty) {
        //
      }
    } else if (event.type === MOUSE_DOWN && data == null) {
      //
    } else if (event.type === MOUSE_UP && data != null) {
      //
    }

    return { mols: updateMols(mols, newMol, molIndex) };
  }

  function preview(state) {
    const { lastMove, molIndex } = state.mouse;
    if (lastMove != null && lastMove.atom) {
      const mouseDownEvent = updateState(lastMove, { type: MOUSE_DOWN });
      const mouseDownPreviewState = baseEffect(state.mols, state.mode, mouseDownEvent, molIndex);
      const mouseUpEvent = updateState(lastMove, { type: MOUSE_UP });
      const previewState = baseEffect(mouseDownPreviewState.mols, state.mode, mouseUpEvent, molIndex);
      const previewMol = previewState.mols[molIndex];

      if (previewMol != null && previewMol !== state.mols[molIndex]) {
        const editedAtoms = {};
        for (const [key, atom] of Object.entries(previewMol.atoms)) {
          if (atom.charge !== state.mols[molIndex].atoms[key].charge) {
            editedAtoms[key] = { ...atom, preview: true, color: null };
          }
        }

        return updateState(previewMol, {
          atoms: updateState(previewMol.atoms, editedAtoms),
        });
      }
    }

    return null;
  }

  function cleanup(mode) {
    return mode;
  }

  return {
    trait: {
      type: modeType,
      initial,
      effect,
      preview,
      cleanup,
    },
  };
}
